export default __webpack_public_path__ + "static/assets/a79393e327040bc73a69fcce682c2d21.svg";